"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Partnership() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const heading = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const lede = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const caption = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.15
  });
  const baseTransition = "transition-all duration-[620ms] ease-[cubic-bezier(0.16,0.84,0.32,1)]";
  const hiddenState = "opacity-0 translate-y-4";
  const visibleState = "opacity-100 translate-y-0";
  return <section data-section-id="20137" id="start-a-partnership" className="bg-background text-foreground py-32 md:py-40">
      <div className="mx-auto w-full max-w-[1240px] px-6 md:px-10 lg:px-16">
        <div className="mx-auto flex max-w-[760px] flex-col items-center text-center">
          {}
          <div ref={eyebrow.ref} className={`flex flex-col items-center ${baseTransition} ${eyebrow.isVisible ? visibleState : hiddenState}`}>
            <span className="font-default text-[0.75rem] font-semibold uppercase text-muted-foreground" style={{
            letterSpacing: "0.14em"
          }}>
              Initial Consultation
            </span>
            <div className="mt-3 flex items-center gap-3">
              <span className="block h-px w-8 bg-border" />
              <span className="block h-1.5 w-1.5 bg-primary" />
            </div>
          </div>

          {}
          <h2 ref={heading.ref} className={`mt-8 font-default font-medium text-foreground ${baseTransition} ${heading.isVisible ? visibleState : hiddenState}`} style={{
          fontSize: "clamp(2.25rem, 4vw, 3.5rem)",
          lineHeight: "1.1",
          letterSpacing: "-0.018em",
          transitionDelay: heading.isVisible ? "80ms" : "0ms"
        }}>
            Initiate a{" "}
            <em className="font-default italic text-primary" style={{
            fontStyle: "italic"
          }}>
              strategic
            </em>{" "}
            dialogue with ITLS.
          </h2>

          {}
          <p ref={lede.ref} className={`mt-8 max-w-[60ch] font-default text-muted-foreground ${baseTransition} ${lede.isVisible ? visibleState : hiddenState}`} style={{
          fontSize: "clamp(1.0625rem, 1.1vw, 1.1875rem)",
          lineHeight: "1.6",
          letterSpacing: "-0.005em",
          transitionDelay: lede.isVisible ? "160ms" : "0ms"
        }}>
            Every engagement begins with a focused discovery session. We listen to your objectives, evaluate your current challenges, and define how our tailored expertise can drive measurable results for your organization. All inquiries are handled with professional discretion.
          </p>

          {}
          <div ref={ctas.ref} className={`mt-12 flex w-full flex-col items-stretch gap-3 sm:w-auto sm:flex-row sm:items-center sm:gap-5 ${baseTransition} ${ctas.isVisible ? visibleState : hiddenState}`} style={{
          transitionDelay: ctas.isVisible ? "240ms" : "0ms"
        }}>
            {}
            <div className="group flex items-center gap-3">
              <span className="hidden h-1.5 w-1.5 shrink-0 bg-primary sm:block" />
              <Button asChild className="h-auto bg-primary px-7 py-3.5 text-primary-foreground hover:bg-primary/90" style={{
              letterSpacing: "0.01em"
            }}>
                <Link to="/ConnectPage">
                  <span className="font-default text-sm font-medium">
                    Request Consultation
                  </span>
                  <ArrowRight className="ml-2 size-4 transition-transform duration-[220ms] group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>

            <Button asChild variant="outline" className="h-auto border border-foreground bg-transparent px-7 py-3.5 text-foreground transition-colors duration-200 hover:bg-foreground hover:text-background" style={{
            letterSpacing: "0.01em"
          }}>
              <Link to="/ConnectPage">
                <span className="font-default text-sm font-medium">
                  Connect with a Partner
                </span>
              </Link>
            </Button>
          </div>

          {}
          <p ref={caption.ref} className={`mt-6 font-default text-muted-foreground ${baseTransition} ${caption.isVisible ? visibleState : hiddenState}`} style={{
          fontSize: "0.8125rem",
          fontWeight: 400,
          transitionDelay: caption.isVisible ? "320ms" : "0ms"
        }}>
            {"Response within one business day · Global Operations"}
          </p>
        </div>
      </div>
    </section>;
}